
import { defineComponent } from 'vue'
import { createValidations, ICustomValidatorMap } from '@/helpers/commons/validationHelper'
import useValidate from '@vuelidate/core'
import descriptor from './LayersManagementLayerTabDescriptor.json'
import KnValidationMessages from '@/components/UI/KnValidatonMessages.vue'
import Textarea from 'primevue/textarea'
import MultiSelect from 'primevue/multiselect'
import Dropdown from 'primevue/dropdown'
import KnInputFile from '@/components/UI/KnInputFile.vue'
import InputSwitch from 'primevue/inputswitch'

export default defineComponent({
    components: { KnValidationMessages, Textarea, MultiSelect, Dropdown, KnInputFile, InputSwitch },
    props: { selectedLayer: { type: Object, required: true }, allRoles: { type: Array, required: true }, allCategories: { type: Array, required: true } },
    computed: {},
    emits: [],
    data() {
        return {
            v$: useValidate() as any,
            descriptor,
            layer: {} as any,
            triggerUpload: false,
            uploading: false,
            layerTypes: [
                {
                    label: this.$t('common.file'),
                    value: 'File'
                },
                {
                    label: this.$t('managers.layersManagement.layerTypes.wfs'),
                    value: 'WFS'
                },
                {
                    label: this.$t('managers.layersManagement.layerTypes.wms'),
                    value: 'WMS'
                },
                {
                    label: this.$t('managers.layersManagement.layerTypes.tms'),
                    value: 'TMS'
                },
                {
                    label: this.$t('managers.layersManagement.layerTypes.google'),
                    value: 'Google'
                },
                {
                    label: this.$t('managers.layersManagement.layerTypes.osm'),
                    value: 'OSM'
                }
            ]
        }
    },
    async created() {
        this.layer = this.selectedLayer
    },
    watch: {
        selectedLayer() {
            this.layer = this.selectedLayer
        }
    },
    validations() {
        const urlRequried = (value) => {
            let types = ['WFS', 'WMS', 'TMS']
            return !types.includes(this.layer.type) || value
        }
        const customValidators: ICustomValidatorMap = { 'url-required': urlRequried }
        const validationObject = { layer: createValidations('layer', this.descriptor.validations.layer as any, customValidators) }
        return validationObject
    },
    methods: {
        setUploadType() {
            this.triggerUpload = false
            setTimeout(() => (this.triggerUpload = true), 200)
        },
        uploadLayerFile(event) {
            this.uploading = true
            let uploadedFile = event.target.files[0]
            this.layer.layerFile = { file: uploadedFile, fileName: uploadedFile.name }
            this.triggerUpload = false
            setTimeout(() => (this.uploading = false), 200)
        }
    }
})
